var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceAbove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#15CF74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72614 12.7261C6.57489 12.8774 6.57489 13.1226 6.72614 13.2739C6.87739 13.4251 7.12261 13.4251 7.27386 13.2739L6.72614 12.7261ZM13.3873 7C13.3873 6.7861 13.2139 6.6127 13 6.6127L9.51432 6.6127C9.30042 6.6127 9.12702 6.7861 9.12702 7C9.12702 7.2139 9.30042 7.3873 9.51432 7.3873H12.6127V10.4857C12.6127 10.6996 12.7861 10.873 13 10.873C13.2139 10.873 13.3873 10.6996 13.3873 10.4857L13.3873 7ZM7.27386 13.2739L13.2739 7.27386L12.7261 6.72614L6.72614 12.7261L7.27386 13.2739Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceAbove);
export default __webpack_public_path__ + "static/media/price-above.f71b579a684aedbbed29aa26884ce20d.svg";
export { ForwardRef as ReactComponent };